import { useRolGetAll } from "../../../fnx/rol/rolGetAll";
import { Rol } from "../../../model/rol";
import LocalStorageService from "../../../services/localStorage";
import { useEffect, useState } from "react";
import { UserInterface } from "../types/types";
import { updateUserRoles } from "../../../resources/helper/userHelper";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);

interface DraggableItem {
	id: string;
	name: string;
	description: string;
}

type SeeToast = {
	show: boolean;
	type: typeAlert;
	message: string;
};
export const useRoleUser = (setSeeToast: (seeToast: SeeToast) => void, setTrigger: (trigger: boolean) => void) => {
    const [rolList, setRolList] = useState<Rol[]>([]);
    const [clientId] = useState<string>(
		lsLogin.getUserLoginStored().clientId
	);
    const [loadingSaveRolPermissions, setLoadingSaveRolPermissions] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<UserInterface  | null>(null);
    const [openDrawerRoles, setOpenDrawerRoles] = useState<boolean>(false);
    const [openDrawerRolesEdit, setOpenDrawerRolesEdit] = useState<boolean>(false);

    const [rolsSelected, setRolsSelected] = useState<Rol[]>([]);

    const [availableItems, setAvailableItems] = useState<DraggableItem[]>([]);
    const [assignedItems, setAssignedItems] = useState<DraggableItem[]>([]);
    const [availableItemsFiltered, setAvailableItemsFiltered] = useState<DraggableItem[]>([]);
    const [assignedItemsFiltered, setAssignedItemsFiltered] = useState<DraggableItem[]>([]);
    const [availableSearch, setAvailableSearch] = useState<string>("");
    const [assignedSearch, setAssignedSearch] = useState<string>("");       


    const { responseRol, errorRol, loadingRol } = useRolGetAll(
		true,
		clientId,
		1,
		20
	);

    const handleAvailableItems = () => {
        setAvailableItems(rolList.map((item: Rol) => ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        })));
        setAvailableItemsFiltered( 
            rolList.map((item: Rol) => ({
                id: item.id,
                name: item.name || "",
                description: item.description || ""
            }))
        );
    }

    const handleAssignedItems = () => {
        setAssignedItems(rolsSelected.map((item: Rol) => ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        })));
        setAssignedItemsFiltered(rolsSelected.map((item: Rol) => ({
            id: item.id,
            name: item.name || "",
            description: item.description || ""
        })));
    }

    const onRoleMove = (itemId: string, from: "available" | "assigned", to: "available" | "assigned") => {
        if (from === "available" && to === "assigned") {
            const rol = availableItems.find((item: Rol) => item.id === itemId);
            if (rol) {
                //update assigned items
                const newAssignedItems = [...assignedItems, rol];   
                setAssignedItems(newAssignedItems);
                setAssignedItemsFiltered(newAssignedItems.filter((item: Rol) => item.name?.toLowerCase().includes(assignedSearch.toLowerCase())));
                   //update available items
                const newAvailableItems = availableItems.filter((item: Rol) => item.id !== itemId);
                setAvailableItems(newAvailableItems);
                setAvailableItemsFiltered(newAvailableItems.filter((item: Rol) => item.name?.toLowerCase().includes(availableSearch.toLowerCase())));
            }
         
        } else if (from === "assigned" && to === "available") {
            const rol = assignedItems.find((item: Rol) => item.id === itemId);
            if (rol) {
                //update available items
                const newAvailableItems = [...availableItems, rol];
                setAvailableItems(newAvailableItems);
                setAvailableItemsFiltered(newAvailableItems.filter((item: Rol) => item.name?.toLowerCase().includes(availableSearch.toLowerCase())));
                //update assigned items
                const newAssignedItems = assignedItems.filter((item: Rol) => item.id !== itemId);
                setAssignedItems(newAssignedItems);
                setAssignedItemsFiltered(newAssignedItems.filter((item: Rol) => item.name?.toLowerCase().includes(assignedSearch.toLowerCase())));
            }
        }
    }

    const onRoleDelete = (itemId: string) => {
        const rol = assignedItems.find((item: Rol) => item.id === itemId);
        if (rol) {
            //update available items
            const newAvailableItems = [...availableItems, rol];
            setAvailableItems(newAvailableItems);
            setAvailableItemsFiltered(newAvailableItems.filter((item: Rol) => item.name?.toLowerCase().includes(availableSearch.toLowerCase())));
            //update assigned items
            const newAssignedItems = assignedItems.filter((item: Rol) => item.id !== itemId);
            setAssignedItems(newAssignedItems);
            setAssignedItemsFiltered(newAssignedItems.filter((item: Rol) => item.name?.toLowerCase().includes(assignedSearch.toLowerCase())));
        }
    }

    const onSaveRolPermissions = async (roles: Rol[]) => {
        console.log("onSaveRolPermissions", roles);
        try {
            setLoadingSaveRolPermissions(true);
            const respnse =await updateUserRoles(selectedUser?.id || "", roles.map((item: Rol) => item.id));
            if (respnse.ok) {
                setSeeToast({
                    show: true,
                    type: typeAlert.success,
                    message: "Roles actualizados correctamente"
                });
                setOpenDrawerRolesEdit(false);
                setTrigger(true);
            } else {
                setSeeToast({
                    show: true,
                    type: typeAlert.error,
                    message: "Error al actualizar los roles"
                });
            }
        } catch (error) {
            console.error(error);
            setSeeToast({
                show: true,
                type: typeAlert.error,
                message: "Error al actualizar los roles"
            });
        } finally {
            setLoadingSaveRolPermissions(false);
        }
    }

    const onAvailableSearchChange = (value: string) => {
        setAvailableSearch(value);
        setAvailableItemsFiltered(availableItems.filter((item: Rol) => item.name?.toLowerCase().includes(value.toLowerCase())));
    }

    const onAssignedSearchChange = (value: string) => { 
        setAssignedSearch(value);
        setAssignedItemsFiltered(assignedItems.filter((item: Rol) => item.name?.toLowerCase().includes(value.toLowerCase())));
    }


    useEffect(() => {
        if (responseRol && responseRol?.data) {
            setRolList(
				responseRol?.data?.map((item: any) => ({
					...item,
					label: item.name,
					value: item.id,
				}))
			);
        }
    }, [responseRol]);

    useEffect(() => {
        console.log("selectedUser", selectedUser);
        if (selectedUser && selectedUser.roles) {
          setRolsSelected(selectedUser.roles);
          handleAvailableItems();
          handleAssignedItems();
        }
    }, [ selectedUser]);

    
    return {
        rolList,
        loadingRol,
        errorRol,
        selectedUser,
        setSelectedUser,
        openDrawerRoles,
        setOpenDrawerRoles,
        rolsSelected,
        openDrawerRolesEdit,
        setOpenDrawerRolesEdit,
        availableItems,
        assignedItems,
        availableItemsFiltered,
        assignedItemsFiltered,
        availableSearch,
        assignedSearch,
        loadingSaveRolPermissions,
        onRoleMove,
        onRoleDelete,
        onSaveRolPermissions,
        onAvailableSearchChange,
        onAssignedSearchChange
    }
}   
